import { useEffect, useState } from "react";
import { collection, onSnapshot, query } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import { FIRESTORE_LEADS_TABLE, FIRESTORE_REGIONS_TABLE } from "../../../constants/FirestoreConstant";
import { COMPANY_COUNTRY_CODE } from "../../../constants/CompanyConstants";
import { message } from "antd";

export const useLeads = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    setIsLoading(true);

    const leadsQuery = query(
      collection(firestore, FIRESTORE_REGIONS_TABLE, COMPANY_COUNTRY_CODE, FIRESTORE_LEADS_TABLE),
    );

    const unsubscribe = onSnapshot(
      leadsQuery,
      (snapshot) => {
        try {
          const leadsData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          setLeads(leadsData);
          setIsLoading(false);
        } catch (err) {
          console.error("Error processing leads snapshot:", err);
          message.error("Failed to process leads data");
          setIsLoading(false);
        }
      },
      (error) => {
        console.error("Error listening to leads:", error);
        message.error("Failed to fetch leads data");
        setIsLoading(false);
      },
    );

    return () => unsubscribe();
  }, []);

  return {
    isLoading,
    leads,
  };
};
